import { createPortal } from 'react-dom';
import { useLocation } from 'react-router-dom';
import { isMobileIslandDockPathEnabled } from './constants';
import { useMobileIslandDock } from './context';
import MobileIslandDockContextual from './MobileIslandDockContextual';
import MobileIslandDockDefault from './MobileIslandDockDefault';

/**
 * 手机底部三岛入口（仅 md 以下，由 App.js 挂载）。
 * 见 docs/internal/frontend/mobile-island-dock.md
 */
const MobileIslandDock = () => {
	const { pathname } = useLocation();
	const { dockConfig } = useMobileIslandDock();

	if (!isMobileIslandDockPathEnabled(pathname)) {
		return null;
	}

	const content = dockConfig ? <MobileIslandDockContextual config={dockConfig} /> : <MobileIslandDockDefault />;

	if (typeof document === 'undefined') {
		return null;
	}

	return createPortal(content, document.body);
};

export default MobileIslandDock;
